import UserActionsMobile from './components/UserActionsMobile'

export default function () {
  return { component: UserActionsMobile }
}
